import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from '../../../../../../../openapi';

@Injectable()
export class DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentTerrainInfoForm extends AppForm {
  constructor() {
    super({
      voivodeship: new FormControl({
        value: 'Dolnośląskie',
        disabled: true
      }, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      county: new FormControl({
        value: 'Wrocławski',
        disabled: true
      }, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      municipality: new FormControl({
        value: 'Długołęka',
        disabled: true
      }, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      postalCode: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      postOffice: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      city: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      street: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      houseNumber: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      apartmentNumber: new FormControl('', Validators.maxLength(255)),

      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
        }
      )
    });
  }

  public get voivodeship(): FormControl {
    return this.get('voivodeship') as FormControl;
  }

  public get county(): FormControl {
    return this.get('county') as FormControl;
  }

  public get municipality(): FormControl {
    return this.get('municipality') as FormControl;
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues({
      ...value,
      parcels: value?.parcels?.filter(v => v.tag === 'parcels') || []
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.parcels;
    return {
      ...value,
      voivodeship: this.voivodeship.value,
      county: this.county.value,
      municipality: this.municipality.value
    };
  }
}
